import styled from 'styled-components'
import { media } from 'app/assets/styles'
import { BORDER, SPACING } from '../../../../../app-v2/design-tokens'
import { colors } from 'app-v2/design-systems'

export const StyledBlock = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    background-color: ${colors.white};
    padding: ${SPACING.XXXL} ${SPACING.XXL} ${SPACING.M};
    ${media.medium`padding: 48px;`}
    border-radius: ${BORDER.RADIUS.XL};
    gap: ${SPACING.XXL};
    ${media.medium`gap: ${SPACING.M};`}
    max-width: 1000px;
`

export const StyledStampContainer = styled.div`
    display: flex;
    position: absolute;
    flex: 1;
    z-index: 1;
    right: 0;
    top: 0;
    img {
        position: absolute;
        right: -${SPACING.XXS};
        top: -${SPACING.XXXL};
        height: 84px;
        ${media.medium`
            right: -${SPACING.L};
            top: -56px;
            height: 154px;
        `}
    }
`
export const StyledCrownContainer = styled.div`
    display: flex;
    position: absolute;
    flex: 1;
    z-index: 1;
    right: -${SPACING.XXS};
    top: ${SPACING.XXL};
    height: 80px;
    ${media.medium`
        top: -${SPACING.XXL};
        left: -${SPACING.XXL};
        height: 100px;
    `}
`

export const StyledExplanationsContainer = styled.div`
    display: flex;
    gap: 32px;
    ${media.medium`flex-direction: row;`}
    flex-direction: ${props =>
        props.mobileReverse ? 'column-reverse' : 'column'};
    margin-top: 50px;
`

export const StyledBodyContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding-top: ${SPACING.L};
    gap: ${SPACING.M};
`

export const StyledPointContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: ${SPACING.XS};
    justify-content: space-around;
    align-items: baseline;
`

export const StyledNumber = styled.div`
    color: ${colors.white};
    background-color: ${colors.bbqBrown};
    border-radius: 50%;
    height: ${SPACING.L};
    width: ${SPACING.XL};
    display: flex;
    align-items: center;
    justify-content: center;
`

export const StyledTextContainer = styled.div`
    width: 100%;
`

export const StyledTitleContainer = styled.div`
    padding-top: ${SPACING.XS};
`
export const StyledTitleWinContainer = styled.div`
    padding-right: 46px;
`

export const StyledExplanationBlockContainer = styled.div`
    flex: 1;
    display: flex;
    position: relative;
    justify-content: center;
    flex-direction: row;
    align-items: stretch;
`

export const StyledIllustrationContainer = styled.div`
    display: flex;
    flex: 1;
    align-content: center;
    justify-content: center;
    img {
        object-fit: contain;
        width: 100%;
        ${media.small`width: 80%;`}
        margin-bottom: 24px;
    }
`

export const StyledIllustrationGainsContainer = styled.div`
    display: flex;
    flex: 1;
    align-content: center;
    justify-content: center;
    padding-top: 320px;
    img {
        object-fit: contain;
        width: 100%;
        position: absolute;
        bottom: 0;
    }
`

export const StyledIllustrationRightContainer = styled.div`
    display: flex;
    flex: 1;
    img {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 40%;
    }
`

export const StyledContainer = styled.div`
    display: flex;
    flex-direction: row;
`

export const StyledLeftContainer = styled.div`
    width: 100%;
    ${media.small`width: 50%;`}
`
